import { render, staticRenderFns } from "./TypeOfContactDashboard.vue?vue&type=template&id=d5abd42e&scoped=true&"
import script from "./TypeOfContactDashboard.vue?vue&type=script&lang=js&"
export * from "./TypeOfContactDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5abd42e",
  null
  
)

export default component.exports